import { Checkbox } from "@/components/ui/checkbox";
import { Package } from "lucide-react";
import { money } from "@/components/StatusBadge";
import { itemShare, coopTotals } from "@/lib/coop";

// Checklist for a joining partner to pick which co-op items they want.
// items: normalized line_items (with item_id + share). selected: Set of item_ids.
export default function CoopItemPicker({ items = [], selected, onToggle }) {
  if (!items.length) return null;
  const totals = coopTotals(items, selected);

  return (
    <div data-testid="coop-item-picker" className="rounded-lg border border-blue-200 bg-blue-50/60 p-3">
      <div className="flex items-center gap-1.5 text-sm font-semibold text-blue-900">
        <Package className="h-4 w-4" /> Pick the items you want
      </div>
      <p className="mt-0.5 text-[11px] text-blue-800">
        Choose which products from this co-op basket you'll take. You pay only your share of those items.
      </p>

      <div className="mt-3 space-y-2">
        {items.map((it) => {
          const checked = selected.has(it.item_id);
          const share = it.share != null ? Number(it.share) : itemShare(it);
          return (
            <label
              key={it.item_id}
              data-testid={`coop-pick-${it.item_id}`}
              className={`flex cursor-pointer items-center gap-3 rounded-md border p-2.5 transition-colors ${
                checked ? "border-blue-400 bg-white" : "border-black/10 bg-white/60"
              }`}
            >
              <Checkbox
                data-testid={`coop-pick-check-${it.item_id}`}
                checked={checked}
                onCheckedChange={() => onToggle(it.item_id)}
              />
              <div className="flex-1 flex items-center gap-2.5">
                {it.image_url && (
                  <img src={it.image_url} alt="" className="h-9 w-9 rounded object-cover border border-black/10" />
                )}
                <div>
                  <p className="text-sm font-medium">{it.name}</p>
                  <p className="text-[11px] text-muted-foreground">Unit price {money(it.unit_price)}</p>
                </div>
              </div>
              <span className="text-sm font-semibold text-accent">{money(share)}</span>
            </label>
          );
        })}
      </div>

      <div className="mt-3 flex items-center justify-between rounded-md bg-white p-2.5 text-sm">
        <span className="text-muted-foreground">Your total share</span>
        <span data-testid="coop-selected-total" className="font-semibold text-accent">{money(totals.shareTotal)}</span>
      </div>
    </div>
  );
}
